import { GET_MILJOLEVERINGSTYPER_SUCCESS } from "../actions/miljoleveringstyperActions";

const INITIAL_STATE = [];

export default function miljoleveringstyperReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case GET_MILJOLEVERINGSTYPER_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
